import React, { useState } from 'react';
import { sizes } from '@/types/image.sizes';

interface Props {
  name: string;
  src?: string | null;
  className?: string;
  q?: number;
  w?: number;
}

const pickSize = (w: number, x = 1) => sizes[Math.ceil((w * x) / 32)];
export default function Avatar({ name = '', src, className = 'h-12 w-12', q = 75, w = 90 }: Props) {
  const [placeholder, setPlaceholder] = useState<string | null>(null);
  const onLoadError = React.useCallback(() => {
    if (!placeholder) setPlaceholder('/placeholder.svg');
  }, []);
  const service = import.meta.env.VITE_IMAGE_SERVICE;
  const isSVG = src?.match && src.match(/\.svg/);

  const _src = service + '?url=' + src + '&w=' + pickSize(w) + '&q=' + q;
  const encodedSrc = encodeURI(String(src));
  const srcSet =
    service +
    '?url=' +
    encodedSrc +
    '&w=' +
    pickSize(w, 2) +
    '&q=' +
    q +
    ' 2x,' +
    service +
    '?url=' +
    encodedSrc +
    '&w=' +
    pickSize(w, 3) +
    '&q=' +
    q +
    ' 3x,' +
    service +
    '?url=' +
    encodedSrc +
    '&w=' +
    pickSize(w, 4) +
    '&q=' +
    q +
    ' 4x';

  return (
    <div
      className={`flex items-center justify-center bg-gray-300 shadow rounded-full overflow-hidden text-xl md:text-2xl lg:text-3xl ${className}`}
    >
      {src ? (
        <img
          src={placeholder || (isSVG ? src : _src)}
          {...(!placeholder && !isSVG ? { srcSet } : {})}
          className='object-contain h-full'
          alt={name}
          onError={onLoadError}
        />
      ) : (
        <span className='font-bold capitalize text-gray-700'>{name[0]}</span>
      )}
    </div>
  );
}
